import { FC } from 'react';

export type LineChartIconProps = {};

export const LineChartIcon: FC<LineChartIconProps> = ({}) => (
  <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M56 56H12.2667C10.7732 56 10.0265 56 9.45603 55.7094C8.95426 55.4537 8.54631 55.0457 8.29065 54.544C8 53.9735 8 53.2268 8 51.7333V8M56 18.6667L41.5085 33.1582C40.9805 33.6862 40.7165 33.9502 40.412 34.0491C40.1442 34.1361 39.8558 34.1361 39.588 34.0491C39.2835 33.9502 39.0195 33.6862 38.4915 33.1582L33.5085 28.1752C32.9805 27.6471 32.7165 27.3831 32.412 27.2842C32.1442 27.1972 31.8558 27.1972 31.588 27.2842C31.2835 27.3831 31.0195 27.6471 30.4915 28.1752L18.6667 40M56 18.6667H45.3333M56 18.6667V29.3333"
      stroke="url(#paint0_linear_101_44443)"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3"
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_101_44443"
        x1="52.8193"
        x2="3.14062"
        y1="53"
        y2="42.8411"
      >
        <stop stop-color="#3EBDDA" />
        <stop offset="1" stop-color="#548CE4" />
      </linearGradient>
    </defs>
  </svg>
);
